import { RootState } from '../../../../rootReducer';

export const aggregationReportSelector = (state: RootState) => state.eventsLogModuleReducer.AggregationReportReducer;
